import React from 'react';
import { usePageBanners } from '../../../hooks/usePageBanners';
import PageBanner from '../PageBanner/PageBanner';
import './AboutHero.css';

const SECTION = 'About Us';

const AboutHero = () => {
  const { hasDynamicBanner, banners } = usePageBanners(SECTION);

  return (
    <section className="about-hero">
      {hasDynamicBanner && <PageBanner banners={banners} />}
      {!hasDynamicBanner && (
        <div className="about-hero-title-section about-hero-title-section--standalone">
          <div className="container">
            <div className="about-hero-content">
              <h1 className="about-title">
                About Us
              </h1>
              <p className="about-subtitle">
                Your Business. One Flow
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default AboutHero;
